import { Stack, Group, Text, Anchor, UnstyledButton } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

interface QAReviewStatusWidgetProps {
  caseData: any;
  hasActiveDiscussion: boolean;
  hasActiveSendOuts: boolean;
  activeSendOutsCount: number;
  onViewDiscussion: () => void;
  onFlagDiscussion: () => void;
  onExternalOpinion: () => void;
}

export function QAReviewStatusWidget({
  caseData,
  hasActiveDiscussion,
  hasActiveSendOuts,
  activeSendOutsCount,
  onViewDiscussion,
  onFlagDiscussion,
  onExternalOpinion,
}: QAReviewStatusWidgetProps) {
  const isBlocked = caseData?.isBlocked;
  const hasIssues = isBlocked || hasActiveDiscussion || hasActiveSendOuts;

  if (!hasIssues) {
    return (
      <Group gap="xs">
        <IconCheck size={14} color="var(--mantine-color-dimmed)" />
        <Text size="sm" c="dimmed">
          No QA flags
        </Text>
      </Group>
    );
  }

  return (
    <Stack gap={6}>
      {isBlocked && (
        <Group gap="xs" wrap="nowrap">
          <Text c="red.6" size="xs" lh={1}>
            ●
          </Text>
          <Text size="sm" fw={500} c="red.6">
            Case blocked
          </Text>
        </Group>
      )}

      {hasActiveDiscussion && (
        <Group gap="xs" wrap="nowrap" justify="space-between">
          <Group gap="xs" wrap="nowrap">
            <Text c="dimmed" size="xs" lh={1}>
              ●
            </Text>
            <Text size="sm">Discussion active</Text>
          </Group>
          <Anchor
            component="button"
            size="xs"
            c="dimmed"
            onClick={onViewDiscussion}
          >
            View
          </Anchor>
        </Group>
      )}

      {hasActiveSendOuts && (
        <Group gap="xs" wrap="nowrap" justify="space-between">
          <Group gap="xs" wrap="nowrap">
            <Text c="dimmed" size="xs" lh={1}>
              ●
            </Text>
            <Text size="sm">
              {activeSendOutsCount} external opinion pending
            </Text>
          </Group>
          <Anchor
            component="button"
            size="xs"
            c="dimmed"
            onClick={onExternalOpinion}
          >
            View
          </Anchor>
        </Group>
      )}

      {!hasActiveDiscussion && (
        <UnstyledButton onClick={onFlagDiscussion} mt={2}>
          <Text size="xs" c="dimmed" td="underline">
            Flag for Discussion
          </Text>
        </UnstyledButton>
      )}
    </Stack>
  );
}
